/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.css';
import TextField from "@/components/textField";
import { cn } from "@/utils/theme/cn";
import useSelectMenuStore from "@/components/select/menu/selectMenuStore";
import { clickHandler, getValue } from "@/components/select/helpers";
import { useTranslations } from "next-intl";
import Adornment from "@/components/select/adornment";
import { useFormContext } from "react-hook-form";
export default function Select(param) {
    let { placeholder, onFocus, useOffset, getTitle, readOnly, className, inputClassName, menuClassName, searchable, error, ref, id, disabled, onChange, onBlur, label, value, clearable = true, options = [], inputProps = {}, onlyKey, moreOnChange, fixed, searchFilter, getTextFieldTitle } = param;
    // hooks
    const formMethods = useFormContext();
    const setData = useSelectMenuStore((state)=>state.setData);
    const T = useTranslations();
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.holder, className),
        onClick: (event)=>{
            clickHandler(setData, useOffset, event, fixed, id, options, (option)=>{
                onChange(option);
                moreOnChange && moreOnChange(option, formMethods);
            }, getTitle, searchable, onlyKey, menuClassName, searchFilter);
        },
        children: /*#__PURE__*/ _jsx(TextField, {
            id: id,
            ref: ref,
            label: label,
            error: error,
            onBlur: onBlur,
            onFocus: onFocus,
            readOnly: readOnly,
            disabled: disabled,
            onChange: onChange,
            inputProps: inputProps,
            placeholder: placeholder,
            className: cn(styles.input, inputClassName),
            value: getValue(value, options, getTextFieldTitle || getTitle, onlyKey, T),
            EndAdornment: /*#__PURE__*/ _jsx(Adornment, {
                clearable: clearable,
                onChange: onChange,
                value: value
            })
        })
    });
}
